const { GRAPHQL_API_URL } = process.env
const { ADMIN_MONOLITH_HOST } = process.env

const baseUrl = GRAPHQL_API_URL
const adminMonolithHost = ADMIN_MONOLITH_HOST || "https://admin.withcove.com"

export default { baseUrl, adminMonolithHost }
